import { z } from "zod";

export const inspectionAddressSchema = z.object({
  street: z.string().trim().min(3, "Please enter the street address.").max(160),
  city: z.string().trim().min(2, "Please enter the city.").max(80),
  state: z.string().trim().regex(/^[A-Za-z]{2}$/, "Please enter the two-letter state."),
  zip: z.string().trim().regex(/^\d{5}(-\d{4})?$/, "Please enter a valid ZIP code."),
});

export function formatInspectionAddress(value: z.infer<typeof inspectionAddressSchema>) {
  return `${value.street.trim()}, ${value.city.trim()}, ${value.state.trim().toUpperCase()} ${value.zip.trim()}`;
}